import { useState, useEffect, useRef } from 'react';

import { ContentField } from '../ContentField/ContentField';

import iframeStyles from './sandboxedIframe.scss?inline';

interface Props {
  content: string;
  className?: string;
}

const getStyledHtml = (content: string): string => {
  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>${iframeStyles}</style>
</head>
<body>${content}</body>
</html>`;
};

export const SandboxedIframe: React.FC<Props> = ({ content, className }) => {
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!iframeRef.current) return;

    const iframe = iframeRef.current;
    const handleLoad = (): void => {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (doc) {
        iframe.style.height = `${doc.body.scrollHeight}px`;
      }
    };

    iframe.addEventListener('load', handleLoad);
    return () => iframe.removeEventListener('load', handleLoad);
  }, [content]);

  if (hasError) {
    return (
      <div className={className}>
        <ContentField icon="no_result" content="Не вдалося відобразити вміст. Спробуйте оновити сторінку." />
      </div>
    );
  }

  return (
    <iframe
      ref={iframeRef}
      className={className}
      sandbox="allow-same-origin"
      srcDoc={getStyledHtml(content)}
      title="HTML Content"
      onError={(): void => setHasError(true)}
      style={{ position: 'static', width: '100%', border: 'none' }}
    />
  );
};
